import { useTranslation } from "./useTranslation";

export const useTranslatedKey = (namespace?: string) => {
  const { i18n } = useTranslation(namespace);

  const getKeyName = (keyBase: string) => `${keyBase}_${i18n.language}`;

  const getTranslatedValue = (obj: object, key: string) => {
    if (!obj) return null;
    const keyName = getKeyName(key); // e.g. field "about_lt"

    // if the translated value exists, return it, otherwise return the default value
    const translatedValue = obj[keyName];
    const defaultValue = obj[key];
    return translatedValue || defaultValue;
  };

  return { getKeyName, getTranslatedValue };
};
